import { apiClient } from '@/lib/api-client';
import type { ApiResponse, UserRole } from '@/types/api';

export interface InviteValidation {
  email: string;
  organizationName: string;
  role: UserRole;
  userExists: boolean;
}

export interface AcceptInviteRequest {
  firstName: string;
  lastName: string;
  password: string;
}

export async function validateInviteToken(token: string): Promise<InviteValidation> {
  const response = await apiClient.get<ApiResponse<InviteValidation>>(`/invites/${token}`);
  return response.data.data!;
}

export async function acceptInvite(token: string, data: AcceptInviteRequest): Promise<void> {
  await apiClient.post(`/invites/${token}/accept`, data);
}
